import { Dropdown } from "@/crud/form/Dropdown";
import { useFormikContext } from "formik";

export const FormModeSelector = () => {
  const { values } = useFormikContext();
  return (
    <>
      <Dropdown
        hideSearch
        isUpdating={true}
        name="mode"
        options={[
          {
            id: "general",
            value: "General",
            label: "Create a form to collect data",
          },
          {
            id: "quiz",
            value: "Quiz",
            label: "Create a quiz to grade answers",
          },
        ]}
      />
    </>
  );
};
